import axiosClient from "@/api/common/axiosClient.ts";
import { Subscription, SubscriptionStatus } from "@/types/subscription.ts";
import { PaginatedResponse } from "@/api/types.ts";

export const getSubscriptions = ({
  status,
}: {
  status?: SubscriptionStatus;
}) => {
  return axiosClient.get<PaginatedResponse<Subscription>>("/subscriptions/", {
    params: { status },
  });
};

export const unsubscribe = ({ id }: { id: number }) => {
  return axiosClient.post<{ status: string }>(
    `/subscriptions/${id}/unsubscribe/`,
  );
};

export const getSubscriptionDraws = ({ id }: { id: number }) => {
  return axiosClient.get<{ status: string }>(`/subscriptions/${id}/draws/`);
};
